let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("klGUa")).then(() => parcelRequire('8o2bj'));